// NOTICE: KAPTION-INTEGRATION
// The text of an activity message: in the viewer's language when the message carries its i18n key,
// else the text the server wrote. Shared by the activity bubble and a group of events
// (note-cards.GROUP.4), so both say the same thing.

// Map backend Rails i18n keys to frontend Vue i18n keys
export const ACTIVITY_KEY_MAP = {
  'conversations.activity.captain.resolved':
    'ACTIVITY_MESSAGES.CAPTAIN.RESOLVED',
  'conversations.activity.captain.open': 'ACTIVITY_MESSAGES.CAPTAIN.OPEN',
  'conversations.activity.status.resolved': 'ACTIVITY_MESSAGES.STATUS.RESOLVED',
  'conversations.activity.status.contact_resolved':
    'ACTIVITY_MESSAGES.STATUS.CONTACT_RESOLVED',
  'conversations.activity.status.open': 'ACTIVITY_MESSAGES.STATUS.OPEN',
  'conversations.activity.status.pending': 'ACTIVITY_MESSAGES.STATUS.PENDING',
  'conversations.activity.status.snoozed': 'ACTIVITY_MESSAGES.STATUS.SNOOZED',
  'conversations.activity.status.auto_resolved_days':
    'ACTIVITY_MESSAGES.STATUS.AUTO_RESOLVED_DAYS',
  'conversations.activity.status.auto_resolved_hours':
    'ACTIVITY_MESSAGES.STATUS.AUTO_RESOLVED_HOURS',
  'conversations.activity.status.auto_resolved_minutes':
    'ACTIVITY_MESSAGES.STATUS.AUTO_RESOLVED_MINUTES',
  'conversations.activity.status.system_auto_open':
    'ACTIVITY_MESSAGES.STATUS.SYSTEM_AUTO_OPEN',
  'conversations.activity.priority.added': 'ACTIVITY_MESSAGES.PRIORITY.ADDED',
  'conversations.activity.priority.updated':
    'ACTIVITY_MESSAGES.PRIORITY.UPDATED',
  'conversations.activity.priority.removed':
    'ACTIVITY_MESSAGES.PRIORITY.REMOVED',
  'conversations.activity.assignee.self_assigned':
    'ACTIVITY_MESSAGES.ASSIGNEE.SELF_ASSIGNED',
  'conversations.activity.assignee.assigned':
    'ACTIVITY_MESSAGES.ASSIGNEE.ASSIGNED',
  'conversations.activity.assignee.removed':
    'ACTIVITY_MESSAGES.ASSIGNEE.REMOVED',
  'conversations.activity.team.assigned': 'ACTIVITY_MESSAGES.TEAM.ASSIGNED',
  'conversations.activity.team.assigned_with_assignee':
    'ACTIVITY_MESSAGES.TEAM.ASSIGNED_WITH_ASSIGNEE',
  'conversations.activity.team.removed': 'ACTIVITY_MESSAGES.TEAM.REMOVED',
  'conversations.activity.labels.added': 'ACTIVITY_MESSAGES.LABELS.ADDED',
  'conversations.activity.labels.removed': 'ACTIVITY_MESSAGES.LABELS.REMOVED',
  'conversations.activity.sla.added': 'ACTIVITY_MESSAGES.SLA.ADDED',
  'conversations.activity.sla.removed': 'ACTIVITY_MESSAGES.SLA.REMOVED',
  'conversations.activity.linear.issue_created':
    'ACTIVITY_MESSAGES.LINEAR.ISSUE_CREATED',
  'conversations.activity.linear.issue_linked':
    'ACTIVITY_MESSAGES.LINEAR.ISSUE_LINKED',
  'conversations.activity.linear.issue_unlinked':
    'ACTIVITY_MESSAGES.LINEAR.ISSUE_UNLINKED',
  'conversations.activity.csat.not_sent_due_to_messaging_window':
    'ACTIVITY_MESSAGES.CSAT.NOT_SENT_DUE_TO_MESSAGING_WINDOW',
  'conversations.activity.auto_resolve.not_sent_due_to_messaging_window':
    'ACTIVITY_MESSAGES.AUTO_RESOLVE.NOT_SENT_DUE_TO_MESSAGING_WINDOW',
  'conversations.activity.muted': 'ACTIVITY_MESSAGES.MUTED',
  'conversations.activity.unmuted': 'ACTIVITY_MESSAGES.UNMUTED',
  'conversations.activity.auto_resolution_message':
    'ACTIVITY_MESSAGES.AUTO_RESOLUTION_MESSAGE',
  // ai-takeover.TAKEOVER.3
  'conversations.activity.kaption_ai.takeover':
    'ACTIVITY_MESSAGES.KAPTION_AI.TAKEOVER',
};

export const activityMessageText = (
  { content, contentAttributes },
  { t, te }
) => {
  const attrs = contentAttributes;
  if (attrs?.i18n_key) {
    const frontendKey = ACTIVITY_KEY_MAP[attrs.i18n_key];
    if (frontendKey && te(frontendKey)) {
      return t(frontendKey, attrs.i18n_params || {});
    }
  }
  // Fallback to raw content for old messages without metadata
  return content;
};
